module.exports = __webpack_public_path__ + "img/Carolina-Salvador-Moliner.fa3181a2.png";